import { UploadOutlined } from '@ant-design/icons'
import type { UploadFile } from 'antd'
import type { UploadChangeParam } from 'antd/es/upload/interface'
import type { FC } from 'react'
import { useCallback, useState } from 'react'

import type { IUploadFileModelProps } from './UploadFile.model'
import { STextWrapp, SUpload, SUploadWrapp } from './UploadFile.styled'

export const UploadFiles: FC<IUploadFileModelProps> = ({
  onChangeCallback,
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>([])

  const handleOnChangeFile = useCallback(
    (file: UploadChangeParam) => {
      setFileList(file.fileList)
      onChangeCallback(file.fileList)
    },
    [onChangeCallback],
  )

  return (
    <SUploadWrapp>
      <SUpload onChange={handleOnChangeFile} fileList={fileList}>
        <STextWrapp>Выберите файлы</STextWrapp>
        <UploadOutlined />
      </SUpload>
    </SUploadWrapp>
  )
}
